import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { licenseKey } from './devextreme-license';
import {config} from 'devextreme/common';

config({ licenseKey });
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
